import script from "./AddressBlockTronSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressBlockTronSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./AddressBlockTronSkeleton.vue?vue&type=style&index=0&id=0915f5f7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0915f5f7"]])

export default __exports__